import React, { useState } from 'react';
import { IconPlay, IconStop } from '../ui-kit/icons.js';
import Sound from 'react-sound';

const SoundSelector = props => {
  const [selectedValue, setSelectedValue] = useState(props.selectedValue || props.options[0].value);
  const [playStatus, setPlayStatus] = useState(Sound.status.STOPPED);

  const stop = () => setPlayStatus(Sound.status.STOPPED);
  const play = () => setPlayStatus(Sound.status.PLAYING);

  const handleChange = event => {
    stop();
    setSelectedValue(event.target.value);
  };

  const selectedOption = props.options.find(o => selectedValue === o.value);
  const urlPresent = selectedOption?.url;

  return (
    <div className="hstack gap-2">
      <div>
        <select value={selectedValue} onChange={handleChange} name={props.inputName} className="form-select">
          {props.options.map(o => (
            <option key={o.value} value={o.value}>
              {o.name}
            </option>
          ))}
        </select>
      </div>
      <div className="mx-1">
        {playStatus == Sound.status.STOPPED && (
          <IconPlay onClick={urlPresent ? play : null} className={urlPresent ? null : 'text-muted'} />
        )}
        {playStatus == Sound.status.PLAYING && <IconStop onClick={stop} />}
        {selectedOption.url && <Sound url={selectedOption.url} playStatus={playStatus} onFinishedPlaying={stop} />}
      </div>
    </div>
  );
};

export default SoundSelector;
